import type {ManifestFeatureComponentStageGfpp, ManifestFeatureGfppDesktopConfig} from '@wix/document-services-types'
import type {ManifestActionValue} from './types'
import {merge, omitBy} from 'lodash'
import {ActionsHelpers} from './ActionsHelpers'
import {COMP_TYPES} from '../../../../constants/constants'
import type {ComponentRepository} from '../../repository/ComponentRepository'

export abstract class BaseActionsBuilder<TOutput> {
    constructor(
        protected readonly componentType: string,
        protected readonly gfpp: ManifestFeatureComponentStageGfpp | undefined
    ) {}

    protected abstract pickSupportedActions(data: ManifestFeatureGfppDesktopConfig): Record<string, ManifestActionValue>

    protected abstract transformToBuilderActions(data: Record<string, ManifestActionValue>): TOutput

    private mergeDafaultsIfNeeded = (
        componentType: ReturnType<ComponentRepository['getComponentType']>,
        gfppFromStage: ManifestFeatureGfppDesktopConfig | undefined = {}
    ): ManifestFeatureGfppDesktopConfig => {
        switch (componentType) {
            case COMP_TYPES.APP_WIDGET_TYPE:
                return merge({}, ActionsHelpers.INITIAL_GFPP_STATE, gfppFromStage)
            default:
                return gfppFromStage
        }
    }

    private filterHidden({iconButtons, ...rest}: ManifestFeatureGfppDesktopConfig) {
        return {
            ...omitBy(rest, ActionsHelpers.isActionHidden),
            ...(iconButtons ? {iconButtons: omitBy(iconButtons, ActionsHelpers.isActionHidden)} : {})
        }
    }

    public build = (): TOutput => {
        const merged = this.mergeDafaultsIfNeeded(this.componentType, this.gfpp?.desktop)
        const filtered = this.filterHidden(merged)
        const picked = this.pickSupportedActions(filtered)
        return this.transformToBuilderActions(picked)
    }
}
